/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgUnderCover56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        d='M32.03 27.655l3.5-3.5-1.06-1.06-3.5 3.5 1.06 1.06zM37.188 40.688h-14v-2.626h14v2.626zM16.625 42a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM45.5 39.375a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1 4.75A3.75 3.75 0 014.75 1H55v4a2.75 2.75 0 01-2.75 2.75H2.5V53.5h10.538a2.617 2.617 0 01-.788-1.875v-3.636a2.75 2.75 0 01-2.5-2.739V33.5a2.75 2.75 0 012.75-2.75h3.037l1.413-9.889a2.75 2.75 0 012.722-2.361h21.03a2.75 2.75 0 012.723 2.361l1.413 9.889H47a2.75 2.75 0 012.75 2.75v11.75a2.75 2.75 0 01-2.5 2.739v3.636c0 .734-.302 1.399-.788 1.875H56V55H1V4.75zM42.788 53.5A2.617 2.617 0 0142 51.625V48H17.5v3.625c0 .734-.302 1.399-.788 1.875h26.076zM4.75 2.5A2.25 2.25 0 002.5 4.75v1.5h49.75c.69 0 1.25-.56 1.25-1.25V2.5H4.75zm38.573 28.25l-1.383-9.677A1.25 1.25 0 0040.703 20h-8.017l-7.656 7.655-1.06-1.06L30.564 20H19.672a1.25 1.25 0 00-1.237 1.073l-1.383 9.677h26.27zM12.5 32.25c-.69 0-1.25.56-1.25 1.25v11.75c0 .69.56 1.25 1.25 1.25H47c.69 0 1.25-.56 1.25-1.25V33.5c0-.69-.56-1.25-1.25-1.25H12.5z'
      />
    </svg>
  );
}

export default SvgUnderCover56;
